/**
 * Global Ask AI shell — keeps the Guide drawer mounted once and exposes
 * `openAskAi()` to the header, sidebar and legacy `/ask-ai` redirects.
 */
import * as React from "react";
import { AskAiDrawer } from "@/components/shell/AskAiDrawer";

interface AskAiContextValue {
  openAskAi: () => void;
}

const AskAiContext = React.createContext<AskAiContextValue | null>(null);

export function AskAiProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const [open, setOpen] = React.useState(false);
  const openAskAi = React.useCallback(() => setOpen(true), []);

  return (
    <AskAiContext.Provider value={{ openAskAi }}>
      {children}
      <AskAiDrawer open={open} onOpenChange={setOpen} />
    </AskAiContext.Provider>
  );
}

export function useAskAi(): AskAiContextValue {
  const ctx = React.useContext(AskAiContext);
  if (!ctx) {
    throw new Error("useAskAi must be used within AskAiProvider");
  }
  return ctx;
}
